import React from 'react';
import {connect} from 'react-redux';

import * as SlotFamilyType from '../constants/SlotFamilyType';

import SlotArrangementPolicy from '../slot-arrangement-policies';

import SingleOutcomeSlot from './slots/SingleOutcomeSlot.jsx';
import MultiOutcomeSlot from './slots/MultiOutcomeSlot.jsx';
import WideSingleOutcomeSlot from './slots/WideSingleOutcomeSlot.jsx';
import WideMultiOutcomeSlot from './slots/WideMultiOutcomeSlot.jsx';
import TotalSlot from './slots/TotalSlot.jsx';
import TennisGameSlot from './slots/tennis/TennisGameSlot.jsx';
import MatchCorrectScoreOutcomeSlot from './slots/soccer/MatchCorrectScoreOutcomeSlot.jsx';
import NamedOutcomeSlot from './slots/NamedOutcomeSlot.jsx';

import slotTypeProvider from '../providers/SlotTypeProvider';
import slotIdProvider from '../providers/SlotIdProvider';
import customSlotIdProvider from '../providers/CustomSlotIdProvider';
import slotFamilyProvider from '../providers/SlotFamilyProvider';
import slotFactory from '../factories/SlotFactory';
import customSlotFactory from '../factories/CustomSlotFactory';

function sortOutcomes(a, b) {
    return a.get('condition') > b.get('condition') ? 1 : -1;
}

class Body extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.number,
        outcomeStore: React.PropTypes.object.isRequired,
        rateStore: React.PropTypes.object.isRequired,
        group: React.PropTypes.object,
        match: React.PropTypes.object,
        gridLocalization: React.PropTypes.object.isRequired,
        nestingLevel: React.PropTypes.number
    };

    static getSlots(sportId, match, groupType, outcomes, rates) {
        let slotsMap = null;
        let slots = null;

        const matchType = match.get('type');

        outcomes.forEach((o) => {
            if (o.get('isHeader')) {
                return;
            }

            if (slotsMap === null) {
                slotsMap = {};
                slots = [];
            }

            let rate;
            if (matchType !== 1) {
                rate = o.get('rates').map((r) => rates.get(r)).find(r => r.get('type') === 1);
            }

            const slotTypes = slotTypeProvider(sportId, groupType, o.get('type'));

            for (let i = 0; i < slotTypes.length; i++) {
                const slotType = slotTypes[i];

                const slotFamily = slotFamilyProvider(sportId, groupType, slotType);

                let slotId;

                if (matchType !== 1) {
                    slotId = customSlotIdProvider(slotType, slotFamily, rate);
                } else {
                    slotId = slotIdProvider(slotType, slotFamily, o);
                }

                let slot = slotsMap[slotId];

                if (slot === undefined) {
                    if (matchType !== 1) {
                        slot = customSlotFactory(slotId, slotType, slotFamily, rate);
                    } else {
                        slot = slotFactory(slotId, slotType, slotFamily, o);
                    }

                    slotsMap[slotId] = slot;
                    slot.position = SlotArrangementPolicy.getPosition(sportId, groupType, slot);
                    slot.sportId = match.get('sportId');

                    let targetIndex;
                    for (targetIndex = 0; targetIndex < slots.length; targetIndex++) {
                        if (Body.comparePositions(slot.position, slots[targetIndex].position) < 0) {
                            break;
                        }
                    }

                    slots.splice(targetIndex, 0, slot);
                }

                slot.outcomes.push(o.get('id'));
            }
        });

        return slots;
    }

    static comparePositions(position1, position2) {
        for (let i = 0; i < Math.min(position1.length, position2.length); i++) {
            if (position1[i] < position2[i]) {
                return -1;
            }

            if (position1[i] > position2[i]) {
                return 1;
            }
        }

        return 1;
    }

    static renderSlot(slot, props) {
        const outcomes = slot.outcomes.map(o => props.groupOutcomes.find(go => go.get('id') === o)).sort(sortOutcomes);

        const slotProps = {
            slot,
            section: props.section,
            sportId: props.sportId,
            match: props.match,
            gridLocalization: props.gridLocalization,
            outcomes
        };

        switch (slot.family) {
            case SlotFamilyType.SINGLE_OUTCOME:
                return (<SingleOutcomeSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.MULTI_OUTCOME:
                return (<MultiOutcomeSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.WIDE_SINGLE_OUTCOME:
                return (<WideSingleOutcomeSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.WIDE_MULTI_OUTCOME:
                return (<WideMultiOutcomeSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.TOTAL:
                return (<TotalSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.TENNIS_GAME:
                return (<TennisGameSlot key={slot.id} {...slotProps} />);

            case SlotFamilyType.SOCCER_MATCH_CORRECT_SCORE:
                return (<MatchCorrectScoreOutcomeSlot key={slot.id} {...slotProps} />);

            //TODO: implement
            case SlotFamilyType.BASKETBALL_TOTAL_UNDER:
                return (<div key={slot.id}>{'BASKETBALL_TOTAL_UNDER'}</div>);

            //TODO: implement
            case SlotFamilyType.BASKETBALL_TOTAL_OVER:
                return (<div key={slot.id}>{'BASKETBALL_TOTAL_OVER'}</div>);

            case SlotFamilyType.NAMED_OUTCOME_SLOT:
                return (<NamedOutcomeSlot key={slot.id} {...slotProps}/>);

            default:
                console.log('unknown family', slot.family);//eslint-disable-line no-console
        }
    }

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.group !== nextProps.group;
    }

    render() {
        const {section, sportId, match, group, outcomeStore, rateStore, gridLocalization, nestingLevel}  = this.props;
        if (group == undefined) {
            return false;
        }

        const groupOutcomes = group.get('outcomes').map((o) => outcomeStore.get(o))
            .filter((o) => o !== undefined);

        const slots = Body.getSlots(sportId, match, group.get('type'), groupOutcomes, rateStore);

        if (slots === null) {
            return false;
        }

        const cls = `event-detailed-view level-${nestingLevel}`;

        const slotProps = {
            section,
            sportId,
            match,
            groupOutcomes,
            gridLocalization
        };

        return (
            <div className={cls}>
                {slots.map((s) => Body.renderSlot(s, slotProps))}
            </div>
        );
    }
}

function select(state, props) {
    const {section, id, gridLocalization} = props;
    const group = state.application.getIn([section, 'groups', id]);

    let sportId;
    let match;

    if (group !== undefined) {
        sportId = group.get('realSportId');
        match = state.application.getIn([section, 'matches', group.get('matchId')]);
    }

    return {
        section,
        sportId,
        match,
        group,
        outcomeStore: state.application.getIn([section, 'outcomes']),
        rateStore: state.application.getIn([section, 'rates']),
        gridLocalization
    };
}

export default connect(select)(Body);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/Body.jsx